import React from 'react'
import CompareListitem from '../../../_components/_webapp/CompareList/CompareListitem'
import { connect } from 'react-redux';
import { IoMdCheckmark, IoMdClose } from 'react-icons/io'
import { compareConstant } from '../../../_constants/Config/compareConfig';
import MultiLanguageTranslation from '../../../_components/Translate/MultiLangTranslate'

class CompareList extends React.Component {
    multiLingualFun = (content,check) => {
         let local = content.replace(":"," ")
         return <MultiLanguageTranslation title={local} />
     }
    render() {
        const { options_master } = this.props.option;
        let output = [];
        if (this.props.data.object == 1) {
            let flag = 0;

            this.props.data.datalist && this.props.data.datalist.forEach(datalist => {

                let keys = datalist ? Object.keys(datalist) : [];
                keys.forEach((key, index) => {
                    if (flag == 0) {
                        output[index] = [];
                        output[index]['key'] = key;
                        output[index]['datalist'] = [];
                    }
                    if (options_master.hasOwnProperty(key)) {
                        options_master[key].map((data, key1) => {

                            if (data.value == datalist[key]) {

                                output[index]['datalist'].push(data.label);
                            }
                        });
                    }
                    else {
                        output && output[index] && output[index]['datalist'].push(datalist[key]);
                    }
                });
                flag++;
            });
        }


        const weighbridge = compareConstant.weighbridge;
        const structure = compareConstant.structure;
        const amenities = compareConstant.amenities;

        // console.log("ssssssssssssssssssssssssssss",this.props.eventKey , this.props.active)
        return <React.Fragment>
            {this.props.eventKey === this.props.active && <div className="compare-wareetab">
                {this.props.active !== 0 && this.props.active !== 7 && this.props.active !== 4 && this.props.active !== 5 ? <table>
                    {
                        this.props.data.object == 1 ?
                            output.map(data => {
                                return <CompareListitem textual={this.props.textual} column={this.props.column} datalist={data.datalist} keyName={data.key} ></CompareListitem>
                            })
                            :
                            <CompareListitem active={this.props.eventKey} textual={this.props.textual} column={this.props.column} datalist={this.props.data.datalist}></CompareListitem>
                    }

                </table> :
                    <table>
                        {this.props.active === 0 && <> {options_master.booking_options.map((key) => {
                            return <tr>
                                <th>{this.multiLingualFun(key.label)}</th>
                                {this.props.warehouses && this.props.warehouses.map((data) => {
                                    return <td>{data && data.booking_options && data.booking_options.match(key.value) ? <IoMdCheckmark size="30" color="#5c6b25" /> : <IoMdClose size="30" color="#6d6e71" />}</td>
                                })}
                            </tr>
                        })}
                        </>}

                        {this.props.active === 5 && <> {amenities && amenities.map((key) => {
                            let temp = false
                            return <tr>
                                <th>{this.multiLingualFun(key.key)}</th>
                                {this.props.warehouses1 && this.props.warehouses1.map((data) => {
                                    options_master.building_features.map((option) => {
                                        if (data && data.amenities && data.amenities.building_features.match(option.value) && key.label === option.label) {
                                            temp = true
                                        }
                                    })
                                    if (data && data.amenities && data.amenities.guard_room === "YES" && key.label === "guard_room") {
                                        temp = true
                                    }
                                    if (data && data.amenities && data.amenities.safety_manual === "YES" && key.label === "safety_manual") {
                                        temp = true
                                    }
                                    if (data && data.amenities && data.amenities.road  && key.label === "road") {
                                        temp = true
                                    }
                                    if (data && data.amenities && data.amenities.lockin_key  && key.label === "lockin_key") {
                                        temp = true
                                    }
                                    if (data && data.amenities && data.amenities.lock_in_period  && key.label === "lock_in_period") {
                                        temp = true
                                    }
                                    return <td>{temp ? <IoMdCheckmark size="30" color="#5c6b25" /> : <IoMdClose size="30" color="#6d6e71" />}</td>
                                })}
                            </tr>
                        })}
                        </>}

                        {this.props.active === 7 && <> {weighbridge && weighbridge.map((key) => {
                            return <tr>
                                <th>{this.multiLingualFun(key.key)}</th>
                                {this.props.warehouses && this.props.warehouses.map((data) => {
                                    if (key.label === 'weighbridge_receipt') {
                                        return options_master.weighbridge_receipt.map((option) => {
                                            if (parseInt(option.value) === parseInt(data.weighbridge[key.label])) {
                                                return <td>{option.label}</td>
                                            }
                                        })
                                    } else {
                                        return <td>{data.weighbridge[key.label]}</td>
                                    }
                                })}
                            </tr>
                        })}
                        </>}

                        {this.props.active === 4 && <> {structure && structure.map((key) => {
                            return <tr>
                                <th>{this.multiLingualFun(key.key)}</th>
                                {this.props.warehouses && this.props.warehouses.map((data) => {
                                    if (options_master.hasOwnProperty(key.label) && key.label !== 'built_in_year') {
                                        return options_master[key.label].map((option) => {
                                            if (parseInt(option.value) === parseInt(data.warehouse_structure[key.label])) {
                                                return <td>{this.multiLingualFun(option.label)}</td>
                                            }
                                        })
                                    } else {
                                        return <td>{data.warehouse_structure[key.label]}</td>
                                    }
                                })}
                            </tr>
                        })}
                        </>}
                    </table>
                }
            </div>}
        </React.Fragment>
    }
}

const mapDispatchToProps = {
    // add: optionActions.add,
}

function mapStateToProps(state) {
    const { option } = state;
    return {
        option
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompareList)
